var RealtimeMessageTrigger = /* @__PURE__ */ ((RealtimeMessageTrigger2) => {
  RealtimeMessageTrigger2["Add"] = "Add";
  RealtimeMessageTrigger2["Update"] = "Update";
  RealtimeMessageTrigger2["Delete"] = "Delete";
  return RealtimeMessageTrigger2;
})(RealtimeMessageTrigger || {});
var RealtimeUpdatesMode = /* @__PURE__ */ ((RealtimeUpdatesMode2) => {
  RealtimeUpdatesMode2["Silent"] = "Silent";
  RealtimeUpdatesMode2["Confirm"] = "Confirm";
  return RealtimeUpdatesMode2;
})(RealtimeUpdatesMode || {});
const domain = "realtime";
const RealtimeServiceSymbol = /* @__PURE__ */ Symbol("RealtimeService");
export {
  RealtimeMessageTrigger,
  RealtimeServiceSymbol,
  RealtimeUpdatesMode,
  domain
};
//# sourceMappingURL=types.js.map
